// Return the standard timezone offset.
// Pacific Standard Time UTC-8, Mountain Standard Time UTC-7, Central
// Standard Time UTC-6, Eastern Standard Time UTC-5
Date.prototype.stdTimezoneOffset = function () {
  var jan = new Date(this.getFullYear(), 0, 1);
  var jul = new Date(this.getFullYear(), 6, 1);
  return -Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset()) / 60;
};
